import type { AalView } from "../aalV2";
import { useAalListQuery } from "../aalV2";

export type WalletAALTableFilters = {
  view: AalView;
  start_date: string;
  end_date: string;
  page?: number;
  size?: number;
  sort?: string;
  money_type?: string;
  agent_id?: string;
  agent_role_id?: string;
  target_user_id?: string;
  username?: string;
};

export type WalletAALTableItem = {
  event_id: string;
  event_sort_key: string;
  created_at: string;
  action_type: string;
  money_type: string;
  amount: string | number;
  operation: string;
  reason: string;
  agent_id: string;
  agent_email: string;
  agent_role_id: string;
  target_user_id: string;
  target_username: string;
};

export const useGetAALWalletTable = (filters: WalletAALTableFilters) => {
  const {
    view,
    start_date,
    end_date,
    page,
    size,
    sort,
    money_type,
    agent_id,
    agent_role_id,
    target_user_id,
    username,
  } = filters;

  return useAalListQuery<WalletAALTableItem>("wallet", view, {
    start_date,
    end_date,
    page,
    size,
    sort,
    filters: {
      money_type,
      agent_id,
      agent_role_id,
      target_user_id,
      username,
    },
  });
};
